<h4 class="font-weight-bold py-3 mb-4">Courses</h4>

<div class="card mb-4">
  <h6 class="card-header">
    Available courses
  </h6>
  <div class="row no-gutters row-bordered">
    <div class="col-sm-12 p-4">
      <div class="course-tile">
        <div class="course-tile-image course-tile-image-1"></div>
        <span class="course-tile-label">WFT Cursus</span>
      </div>
      <div class="course-tile">
        <div class="course-tile-image course-tile-image-3"></div>
        <span class="course-tile-label">PA Cursus</span>
      </div>
      <div class="course-tile">
        <div class="course-tile-image course-tile-image-4"></div>
        <span class="course-tile-label">PE Cursus</span>
      </div>
      <div class="course-tile">
        <div class="course-tile-image course-tile-image-2"></div>
        <span class="course-tile-label">Excel Cursus</span>
      </div>
      <div class="course-tile">
        <div class="course-tile-image course-tile-image-5"></div>
      </div>
    </div>
  </div>

</div>
